import { Price } from "../../price";
import { Direction } from "../lazertrader/types";

export const marginFromPrice = (
  price: Price,
  reference: Price,
  direction: Direction
): Price =>
  Price.fromYenPerMwh(
    direction === Direction.BUY
      ? reference.yenPerMwh - price.yenPerMwh
      : price.yenPerMwh - reference.yenPerMwh
  );

export const priceFromMargin = (
  margin: Price,
  reference: Price,
  direction: Direction
): Price =>
  Price.fromYenPerMwh(
    direction === Direction.BUY
      ? reference.yenPerMwh - margin.yenPerMwh
      : reference.yenPerMwh + margin.yenPerMwh
  );
